/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';
import { motion, useMotionValue, useSpring, useViewportScroll } from 'framer-motion';
import RecommendButton from '../../common/molecule/RecommendButton';

const MotionFlex = motion<FlexProps>(Flex);

const HoverBar: React.FC = () => {
  const { scrollY } = useViewportScroll();
  const pureBarPosition = useMotionValue(0);
  const barPosition = useSpring(pureBarPosition);
  scrollY.onChange(() => {
    if (scrollY.getVelocity() > 0) {
      pureBarPosition.set(300);
    } else {
      pureBarPosition.set(0);
    }
  });
  return (
    <MotionFlex
      bottom={8}
      left={0}
      position='fixed'
      w='100%'
      direction='column'
      align='center'
      justify='center'
      style={{ y: barPosition }}
      py={4}
    >
      <RecommendButton width='80%' variant='secondary' boxShadow='lg' maxW='md' text='다시 추천 받을래요' />
    </MotionFlex>
  );
};

export default HoverBar;
